import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BadgeState, ChartBadgesObjectPerDateState, ChartBadgesObjectState } from "../reducers/badge.reducer";

const selectBadgeFeature = createFeatureSelector<any>('badges');

export const selectAllBadges = createSelector(
  selectBadgeFeature,
  (state: any) => state
)

export const selectAllChartBadges = createSelector(
  selectBadgeFeature,
  (state: any) => state.chartsObjects
)

export const selectAllChartBadgesPerDate = createSelector(
  selectBadgeFeature,
  (state: any) => state.chartsObjectsByDates
)
export const selectOneBadgeById = (badgeId: number) =>
  createSelector(
    selectAllBadges,
    (badges: any) => {
      return badges.filter((badge: any) => badge.id === badgeId)
    }
  );
